/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}

export const getPagoDocumentoBooking = async (oid: number): Promise<any[]> => {
  try {
    const res = await apiClient.post<ApiResponse<any[]>>(
      Endpoints.PagoDocumentoBooking,
      {
        oidLiquidacion: oid,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
